import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import { AuthService } from '../../../services/api/auth/AuthService';

interface MicrosoftLoginButtonProps {
    disabled?: boolean;
}

export const MicrosoftLoginButton: React.FC<MicrosoftLoginButtonProps> = ({
    disabled = false,
}) => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);

    const handleMicrosoftLogin = async () => {
        setLoading(true);
        try {
            await AuthService.loginWithMicrosoft();
        } catch (error) {
            alert('Não foi possível iniciar o login com Microsoft. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            startIcon={<MicrosoftIcon />}
            variant="contained"
            fullWidth
            onClick={handleMicrosoftLogin}
            disabled={disabled || loading}
            sx={{
                mt: 2,
                borderColor: theme.palette.grey[400],
                color: theme.palette.text.primary,
                '&:hover': {
                    borderColor: theme.palette.grey[600],
                },
            }}
            aria-label="Login com Microsoft"
        >
            {loading ? 'Iniciando login...' : 'Entrar com Microsoft'}
        </Button>
    );
};